import { api, flashMessage } from '../util';

(function ($) {
	/****************** Deleting labels ****************/
	$(document).on('click', '.btn-delete-procedure-document-label', function () {
		let element = $(this).parents('.p-label');
		let url = $(this).attr('href');

		api.delete(url).done(function (response) {
			element.remove();
		});

		return false;
	});

	/****************** Adding labels ****************/
	$(document).on('submit', '.add-procedure-document-label-form', function (e) {
		e.stopImmediatePropagation();

		let form = $(this);
		let button = form.find('.btn-submit');
		let labelId = form.find('[name=labelId]').val();

		if (labelId == null) {
			return false;
		}

		let labelIdTrimmed = labelId.trim();

		if (labelIdTrimmed.length === 0) {
			return false;
		}

		button.prop('disabled', true);
		processApiRequest(this).always(function () {
			button.prop('disabled', false);
		});

		return false;
	});

	let processApiRequest = function (formSelector) {
		let form = $(formSelector);
		let url = getApiUrlFromForm(form);

		return api.post(url, {}).done(function (response) {
			processApiResponse(response, form);
		});
	};

	let getApiUrlFromForm = function (form) {
		let procedureId = form.find('[name=procedureId]').val();
		let documentId = form.find('[name=documentId]').val();
		let labelId = form.find('[name=labelId]').val();
		return (
			'/admin/procedures/' +
			encodeURIComponent(procedureId) +
			'/documents/' +
			encodeURIComponent(documentId) +
			'/labels/' +
			encodeURIComponent(labelId)
		);
	};

	let processApiResponse = function (response, form) {
		let labelItemId = response.id;
		let label = response.label;
		let labelFullName = label.fullName;

		let labelsContainer = form.parents('.labels-container');
		let labelsList = labelsContainer.find('.procedure-document-labels-list');
		if (labelsList.find('[data-procedure-label-item-id="' + labelItemId + '"]').length === 0) {
			let name = $('<span>').addClass('procedure-document-label-item').text(labelFullName);

			let deleteUrl =
				'/admin/procedures/' +
				encodeURIComponent(response.procedureId) +
				'/documents/' +
				encodeURIComponent(response.documentId) +
				'/labels/' +
				encodeURIComponent(response.id);
			let deleteLink = $('<a>').attr('href', deleteUrl).addClass('btn-delete-procedure-document-label').text('x');

			let p = $('<p>')
				.addClass('p-label btn btn-info btn-sm')
				.attr('data-procedure-label-item-id', labelItemId)
				.append(name)
				.append(' ')
				.append(deleteLink);

			labelsList.append(p);
			labelsContainer.find('.mark-labels-checked-container').show();
			flashMessage.show('success', 'Label přidán');
		}

		form.find('[name=labelId]').val('').trigger('change');
	};

	/****************** Marking labels as finished ****************/
	$(document).on('click', '.btn-procedure-document-label-checked', function () {
		let parentElement = $(this).parents('.mark-labels-checked-container');
		let url = $(this).attr('href');
		api.post(url).done(function (response) {
			flashMessage.show('success', 'Labely zkontrolovány / dokončeny');
			parentElement.remove();
		});

		return false;
	});
})(jQuery);
